









































import Input from '../../common/Input/Input.vue';
import DeleteButton from '../../common/Button/DeleteButton.vue';
import Vue, { PropType } from 'vue';
import { isUnique } from '@/utils/array';
import { numToKor } from '@/utils/parsers';
import UniversalBarChart from '@/components/common/Chart/UniversalBarChart.vue';

export default Vue.extend({
  components: { Input, DeleteButton, UniversalBarChart },
  props: {
    value: {
      type: Object as PropType<{ [className: string]: number }>,
    },
  },
  data(): {
    classList: { name: string; value: number }[];
    isValid: boolean;
  } {
    return {
      classList: [{ name: '', value: 0 }],
      isValid: false,
    };
  },
  computed: {
    series(): number[] {
      return this.classList.map((v) => v.value);
    },
    labels(): string[] {
      return this.classList.map((v) => v.name);
    },
    quantityGoalNaturalLanguage(): string[] {
      return this.classList.map((v) =>
        isNaN(+v.value) ? '' : numToKor(v.value),
      );
    },
  },
  watch: {
    classList: {
      handler: function (val: { name: string; value: number }[]) {
        const nameList: string[] = [];
        const valList: number[] = [];
        const rtValue: { [className: string]: number } = {};
        for (let i = 0; i < val.length; i++) {
          const { name, value } = val[i];
          nameList[i] = name;
          valList[i] = +value;
          rtValue[name] = +value;
        }
        const notUnique = !isUnique(nameList);
        const hasNaNOrZero = valList.some(
          (val: number | string) =>
            isNaN(val as number) || val === 0 || val === '',
        );
        const hasNoElement = nameList.length === 0 && valList.length === 0;

        if (notUnique || hasNaNOrZero || hasNoElement) {
          this.isValid = false;
          this.$emit('input', undefined);
        } else {
          this.isValid = true;
          this.$emit('input', rtValue);
        }
      },
      deep: true,
    },
  },
  methods: {
    addClass() {
      this.classList.push({ name: '', value: 0 });
    },
    deleteItem(index: number) {
      this.classList.splice(index, 1);
    },
  },
});
